import React, { useState, useEffect } from 'react';
import { GuiarMetrics } from '../utils/metrics';

const PrivacyBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const accepted = localStorage.getItem('privacyAccepted');
        if (!accepted) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('privacyAccepted', 'true');
        setVisible(false);
        GuiarMetrics.trackPolicyAcceptance();
    };

    if (!visible) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            right: '20px',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
            padding: '20px',
            borderRadius: '10px',
            zIndex: 1000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            border: '1px solid #ddd',
            backdropFilter: 'blur(5px)'
        }}>
            <p style={{ margin: '0 0 15px 0', fontSize: '14px', textAlign: 'center' }}>
                Utilizamos cookies y tratamos sus datos personales para mejorar su experiencia y cumplir con la Ley 1581 de 2012.
                Al navegar en este sitio, acepta nuestra <a href="#/politica" style={{ color: '#007bff', fontWeight: 'bold' }}>Política de Tratamiento de Información</a>.
            </p>
            <button
                onClick={handleAccept}
                className="btn2"
                style={{ cursor: 'pointer', padding: '10px 30px', border: 'none', borderRadius: '5px' }}
            >
                Aceptar y Continuar
            </button>
        </div>
    );
};

export default PrivacyBanner;
